import React, { useState, Fragment } from 'react';

import ViewportItemRow from '../components/ViewportItemRow';
import MapFitBoundsRow from '../components/MapFitBoundsRow';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisH, faToggleOn, faToggleOff,  faEyeSlash, faMapMarkerAlt, faRoute} from '@fortawesome/free-solid-svg-icons'


import Dropdown from 'react-bootstrap/Dropdown'

import {  useLocation } from "react-router-dom";
// import history from "../util/history";

import Offcanvas from 'react-bootstrap/Offcanvas'

import { useSelector, useDispatch } from 'react-redux'

import {setViewportItemLastStateVisibility, setViewportItemTrajectoryVisibility,
  setViewportItemChartVisibility, setComparisonTimeVisibility} from '../state/viewportItemActions'

/** Holds, refreshes and renders viewport properties and items, as state. */
export default function ViewportMenuContainer(props)  {
  // console.log(props) // URLSearchParams(), .search
  let query = new URLSearchParams(props.location.search)
  let focus = query.getAll('focus') 

  const dispatch = useDispatch(); 
  const [showViewport, setShowViewport] = useState(true); 
  const viewport = useSelector((state) => state.viewport.viewport)
  const map = useSelector((state) => state.ui.map)
  
  const handleClose = () => {
    setShowViewport(false);
    dispatch({ type: TOGGLE_MENU_VISIBILITY })
  }
  const handleShow = () => setShowViewport(true);

  // while still loading items:
  if (! viewport.items ) {
      return ( <div className="viewport menu-item-block">LOADING...</div> ) ;
  }
  // items loaded:
  else {
    const setAllItemsVisibility = (visible) => {  
      viewport.items.map( (item, index) => {
        // handleClick(item.key, visible)
        dispatch (setViewportItemLastStateVisibility(item.viewport_item_id, visible, false) )
        dispatch (setViewportItemTrajectoryVisibility(item.viewport_item_id, visible, false) )
      })
    }    
    return (
      <div className="viewport menu-item-block">
        
        <Dropdown>
          <div className="d-grid gap-2"> 
            <Dropdown.Toggle variant="outline-secondary" className="menu-item-row allSelector btn-sm text-left">
              ÖSSZES 
              <span style={{ float: 'right' }}>
                <FontAwesomeIcon icon={faEllipsisH} /> 
              </span>
            </Dropdown.Toggle>
          </div>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setAllItemsVisibility(false)}>kikapcsol</Dropdown.Item>
            <Dropdown.Item onClick={() => setAllItemsVisibility(true)}>bekapcsol</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* 
        <div className="dropdown-menu allSelectorMenu">
          <a className="dropdown-item btn btn-sm" style={{display: 'flex'}} href="#"
            onClick={() => this.setAllItemVisibility('hidden')}>
            <div style={{width: '30px'}}><FontAwesomeIcon icon={faEyeSlash} color="grey"/></div>
            <div style={{flexGrow: '1'}}> &nbsp; kikapcsol</div>
          </a>
          <a className="dropdown-item btn btn-sm" style={{display: 'flex'}} href="#"
            onClick={() => this.setAllItemVisibility('lastStates')}>
            <div style={{width: '30px'}}><FontAwesomeIcon icon={faMapMarkerAlt} color="green"/></div>
            <div style={{flexGrow: '1'}}> &nbsp; hol vannak</div>
          </a>
          <a className="dropdown-item btn btn-sm" style={{display: 'flex'}} href="#"
            onClick={() => this.setAllItemVisibility('trajectories')}>
            <div style={{width: '30px'}}>
              <FontAwesomeIcon icon={faMapMarkerAlt} color="green"/> <FontAwesomeIcon icon={faRoute} color="green"/></div>
            <div style={{flexGrow: '1'}}>&nbsp; merre mentek</div>
          </a>
          <a>
              <MapFitBoundsRow
                name={'zoom'}
                getMap={this.props.getMap}
                itemMoLastStates={this.props.itemMoLastStates}
                itemLastStateVisible={this.props.itemLastStateVisible}
              /> 
            </a>
        </div>
        */}
        { viewport.items.map(
            (item, index) => {
              if (JSON.parse(item.config)) {
                if (JSON.parse(item.config).hidden) return ;
                // set default visibility
                // this.props.setViewportItemLastStateVisibility(id, JSON.parse(item.config).lastStateVisible, true) ;
                // JSON.parse(item.config).trajectoryVisible ;
                // JSON.parse(item.config).chartVisible ;
              }
              var id = item.viewport_item_id ;
              var key = 'nokey'
              try {
                key = JSON.parse(item.config).key 
              }
              catch {
                console.log('WARN: invalid / no item key.')
              }   
              
              return ( 
                <Fragment key={'row:' + index}>
                  <ViewportItemRow
                    viewportItemIndex={index}
                    viewportItemId={item.viewport_item_id}
                    viewportItemKey={key} 
                    focused={focus.includes(key)}
                    location={props.location}
                    map={map}
                    // TODO: 
                    // browserHistory={history}
                  />
                </Fragment>
              )
            }
          )
        }
      </div>

    ) ;

    // for (var i in this.props.viewport.items) {
    //  var item = this.props.viewport.items[i] ;
    //  var id = this.props.viewport.items[i].viewportItemId ;
    //  var row = this.renderItem(id, item) ;
    //  //rows.push(row) ;
    //}

  }
}

//setAllItemVisibility(visibility) {
//  console.log("setAllItemVisibility:", visibility )
//  this.props.viewport.viewport.items.map(
//    (item, index) => { 
//        if (visibility=='hidden') {
//          this.props.setViewportItemTrajectoryVisibility(item.viewport_item_id, false, false) ;  
//          this.props.setViewportItemLastStateVisibility(item.viewport_item_id, false, false) ;
//        }
//        else if (visibility=='lastStates') {
//          this.props.setViewportItemTrajectoryVisibility(item.viewport_item_id, false, false) ;  
//          this.props.setViewportItemLastStateVisibility(item.viewport_item_id, true, false) ;
//        }
//        else if (visibility=='trajectories') {
//          this.props.setViewportItemLastStateVisibility(item.viewport_item_id, true, false) ;
//          this.props.setViewportItemTrajectoryVisibility(item.viewport_item_id, true, false) ;  
//        }
//    }
//  )
//}

//const mapStateToProps = state => {
//  return {
//    viewport:  state.viewport
//  }
//}
//
//const mapDispatchToProps = (dispatch, ownProps) => {
//  return {
//    setViewportItemLastStateVisibility: (viewportItemId, visibility, isDefault) => {
//      dispatch (setViewportItemLastStateVisibility(viewportItemId, visibility, isDefault))
//    }, 
//    setViewportItemTrajectoryVisibility: (viewportItemId, visibility, isDefault) => {
//      dispatch ( setViewportItemTrajectoryVisibility(viewportItemId, visibility, isDefault) )
//    }
//  }
//}

//export default connect(
//  mapStateToProps, mapDispatchToProps
//)(ViewportContainer);
